module.exports = "/_next/static/images/huoqubaojia-9af912c88040e42137b005c854edbc5e.png";